<template>
    <Widget :title="title" :info="info" :important="important" :upselling="upselling" :loading="loading" :report-mode="reportMode">
        <div class="text-center py-3">
            <span class="display-1 chart-value" :class="computeTextClass">{{ data }}</span>
        </div>

        <div v-if="hasSlot()">
            <div class="text-center d-block py-1">
                <v-btn small text color="blue" @click="reveal = !reveal">{{ revealOpen }}</v-btn>
            </div>
            <v-slide-y-reverse-transition>
                <v-card v-show="reveal" elevation="0" class="reveal--content">
                    <v-list-item>
                        <WidgetHeader :title="revealTitle"/>

                        <v-list-item-icon v-ripple @click="reveal = !reveal" style="cursor: pointer">
                            <v-icon>mdi-close</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                    <slot></slot>        
                </v-card>
            </v-slide-y-reverse-transition>
        </div>
    </Widget>
</template>

<script>
import Widget from '@/components/dashboard/Widget';
import WidgetHeader from '@/components/dashboard/WidgetHeader';

/**
 * SingleValueChart is a visual component that displays a provided values in 
 * with its label. It also allows to include a inner widget that is showed on 
 * click over a customizable button.
 */
export default {
    name: 'SingleValueChart',
    props: {
        title: {
            type: String,
            required: true
        },
        info: {
            type: String,
            default: null
        },
        data: {
            required: true
        },
        loading: {
            type: Boolean,
            defaul: false
        },
        revealTitle: {
            type: String,
            default: ''
        },
        revealOpen: {
            type: String,
            default: 'Open'
        },
        important: {
            type: Boolean,
            default: false
        },
        upselling: {
            type: Boolean,
            default: false
        },
        reportMode: {
            type: String,
            required: false
        }
    },
    data: () => ({ reveal: false }),
    methods: {
        hasSlot() {
            return !!this.$slots.default;
        }
    },
  computed:
  {
    computeTextClass() {
      if(this.important) return 'blue--text font-weight-bold';
      if(this.upselling) return 'orange--text font-weight-bold';
      return '';
    }
  },
    components: { Widget, WidgetHeader }
}
</script>

<style scoped>
    .reveal--content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .chart-value { font-size: 3em !important}
</style>